<template>
    <section class="layout">
      <!-- Background Elements -->
      <div class="background-blobs">
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
         <div class="blob blob-3"></div>
      </div>
      <configurer-header class="sticky-top glass-header"/>

      <main class="main-content">
        <div class="glass-container">
            <h4 class="title-header" v-if="!isWelcome">MSDAT Configurer</h4>
            <stepper class="text-center" v-if="showSteps" />

            <transition name="fade" mode="out-in">
                <landing v-if="isWelcome" />
                <div class="routes" v-else >
                    <router-view />
                </div>
            </transition>
        </div>
      </main>
    </section>
</template>

<script>
import { RouterView } from 'vue-router';
import stepper from './components/stepper.vue';
import landing from './landing.vue';
import ConfigurerHeader from './components/configurerHeader.vue';

export default {
  components: {
    RouterView,
    landing,
    stepper,
    ConfigurerHeader,
  },
  computed: {
    isWelcome() {
      return this.$route.path === '/configure';
    },
    showSteps() {
      return this.$route.meta?.step;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/abstracts/_variables.scss';

// Glassmorphism Variables
$glass-bg: rgba(255, 255, 255, 0.7);
$glass-border: rgba(255, 255, 255, 0.5);
$glass-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
$primary-gradient: linear-gradient(135deg, #007D53 0%, #2E8B57 100%);

section.layout {
  min-height: 100vh;
  position: relative;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%); // Fallback/Base
  overflow-x: hidden;
  font-family: 'Inter', sans-serif;
}

.background-blobs {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;
    pointer-events: none;

    .blob {
        position: absolute;
        border-radius: 50%;
        filter: blur(80px);
        opacity: 0.6;
    }

    .blob-1 {
        top: -10%;
        left: -10%;
        width: 600px;
        height: 600px;
        background: rgba(0, 125, 83, 0.2); // Primary Green
        animation: float 20s infinite alternate;
    }

    .blob-2 {
        bottom: -20%;
        right: -10%;
        width: 700px;
        height: 700px;
        background: rgba(52, 132, 129, 0.2); // Secondary Teal
         animation: float 25s infinite alternate-reverse;
    }
     .blob-3 {
        top: 40%;
        left: 40%;
        width: 400px;
        height: 400px;
        background: rgba(255, 184, 0, 0.1); // Accent Yellow
         animation: float 22s infinite alternate;
    }
}

@keyframes float {
    0% { transform: translate(0, 0) rotate(0deg); }
    100% { transform: translate(30px, 50px) rotate(10deg); }
}

.glass-header {
    background: rgba(255, 255, 255, 0.8) !important;
    backdrop-filter: blur(10px);
    border-bottom: 1px solid $glass-border;
    z-index: 100;
}

.main-content {
    position: relative;
    z-index: 1;
    min-height: calc(100vh - 80px); // Adjust based on header height
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 40px 20px;
}

.glass-container {
    width: 100%;
    max-width: 1200px; // Wider container
    background: $glass-bg;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-radius: 24px;
    border: 1px solid $glass-border;
    box-shadow: $glass-shadow;
    padding: 20px;
    transition: all 0.3s ease;
    margin-top: 20px;

    // For specific routes/views (like Landing), we might want to remove the container padding/bg
    &:has(.landing-box) {
         background: transparent;
         box-shadow: none;
         border: none;
         backdrop-filter: none;
         padding: 0;
    }
}

.title-header {
  text-align: center;
  display: block;
  padding: 20px 0;
  font-weight: 700;
  letter-spacing: -0.5px;
  color: #2c3e50;
  margin-bottom: 0;
  background: transparent; // Removed card bg
}

.layout .routes {
  padding: 20px;
  // overflow-x: auto; // Handle inside views if needed
}

// Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
